import { render } from "./AdvancedElementsPage.vue?vue&type=template&id=b7ec924c&ts=true"
import script from "./AdvancedElementsPage.vue?vue&type=script&lang=ts"
export * from "./AdvancedElementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__